import React from "react";
const BellFilled = ({ ...r }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...r}
    >
      <path
        fill="#272727"
        d="M20 17h2v2H2v-2h2v-7a8 8 0 1116 0v7zM9 21h6v2H9v-2z"
      ></path>
    </svg>
  );
};

export default BellFilled;
